import * as ramda from 'ramda';
const identifiersFromTree = content => {
  if (!content) {
    return [];
  }
  const identifiers = Object.keys(content);
  if (identifiers.length === 0) {
    return [];
  }
  const allIdentifiers = [];
  identifiers.forEach(identifier => {
    const childContent = content[identifier];
    if (childContent.children) {
      const childIdentifiers = identifiersFromTree(childContent.children);
      allIdentifiers.push(...childIdentifiers);
    } else {
      allIdentifiers.push(identifier);
    }
  });
  return allIdentifiers;
};
const identifierExistsInTree = (root, identifier) => {
  const keys = Object.keys(root || {});
  if (keys.length === 0) {
    return false;
  }
  if (keys.some(key => key === identifier) && root[identifier] !== null) {
    return true;
  }
  return keys.some(key => {
    const selection = root[key];
    if (selection && selection.children) {
      return identifierExistsInTree(selection.children, identifier);
    }
    return false;
  });
};
const titleForIdentifier = (root, identifier) => {
  const keys = Object.keys(root || {});
  if (keys.length === 0) {
    return '';
  }
  if (keys.some(key => key === identifier) && root[identifier] !== null) {
    return root[identifier].title;
  }
  let title = '';
  keys.some(key => {
    const selection = root[key];
    if (selection && selection.children) {
      const child = titleForIdentifier(selection.children, identifier);
      if (child !== '') {
        title = "".concat(selection.title, ": ").concat(child);
        return true;
      }
    }
    return false;
  });
  return title;
};
const removeFromTree = (root, identifier) => {
  const safeRoot = ramda.clone(root);
  const keys = Object.keys(safeRoot || {});
  if (keys.length === 0) {
    return safeRoot;
  }
  if (keys.some(key => key === identifier)) {
    safeRoot[identifier] = null;
    return safeRoot;
  }
  keys.forEach(key => {
    const selection = safeRoot[key];
    if (selection && selection.children) {
      const children = removeFromTree(selection.children, identifier);
      if (!Object.keys(children).some(childKey => children[childKey] !== null)) {
        safeRoot[key] = null;
      } else {
        selection.children = children;
      }
    }
  });
  return safeRoot;
};
const _getPaths = function getPaths(root) {
  let paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const childPaths = [];
  const keys = Object.keys(root);
  keys.forEach(key => {
    const child = root[key];
    if (!child) {
      return;
    }
    const keyPaths = paths.concat([child.title]);
    if (child.children) {
      const children = _getPaths(child.children, keyPaths);
      childPaths.push(...children);
    } else {
      childPaths.push(keyPaths);
    }
  });
  return childPaths;
};
const pruneTree = root => {
  let safeRoot = ramda.clone(root || {});
  const keys = Object.keys(safeRoot);
  if (keys.length === 0) {
    return null;
  }
  safeRoot = keys.reduce((acc, key) => {
    let tree = acc[key];
    if (tree === null) {
      return acc;
    }
    if (tree.children) {
      tree.children = pruneTree(tree.children);
    }
    if (tree.children === null) {
      tree = null;
    }
    acc[key] = tree;
    return acc;
  }, safeRoot);
  if (!keys.some(key => !!safeRoot[key])) {
    return null;
  }
  return safeRoot;
};
const leafSelectionsToSubtitle = (root, selections) => {
  const lens = ramda.lensPath(selections.reduce((all, current) => all.concat(current.identifier, 'children'), []));
  const safeRoot = ramda.view(lens, root);
  const paths = _getPaths(safeRoot || {});
  return paths.map(path => ramda.last(path)).join(', ');
};
export { identifierExistsInTree, pruneTree, leafSelectionsToSubtitle, removeFromTree, titleForIdentifier, identifiersFromTree };